import React from 'react';
import InputSelectFilter from '../../../inputs/InputSelectFilter';

export default function SelectPetType({ className , value, data, setValue }) {
  let productOptions = [{ label: 'Pet Type', value: 0 }];
  data.forEach(product => {
    productOptions.push({label: product.name, value: product.ID})
  })

  return (
  <InputSelectFilter
    className={`select-pet-type ${ className || '' }`}
    placeholder='Pet Type'
    aria-label="Pet Type"
    value={value}
    onChange={target => setValue(target.value)}
  >
    {
    productOptions.map(({ label, value }, i) => (
    <option
      key={i}
      value={value}
    >
      { label }
    </option>
    ))
    }
  </InputSelectFilter>  
  );
}
